<template>
  <v-card class="main-content-card" flat id="proj-review-card">
    <v-toolbar flat>
      <v-toolbar-title>项目申报管理</v-toolbar-title>
      <span class="subheading ml-2">|</span>
      <v-btn round small color="orange darken-1" class="white--text"
             @click.native.stop="() => { editDbid = null; edit = true; }">
        <v-icon>playlist_add</v-icon>
        新的申报
      </v-btn>
    </v-toolbar>
    <v-divider/>
    <v-form ref="formRef">
      <v-container grid-list-md class="pt-0">
        <v-layout wrap>
          <v-flex xs3>
            <v-text-field
                label="申报名称"
                :rules="rules.required"
                v-model="form.name"
            />
          </v-flex>

          <v-flex sm3>
            <v-menu
                ref="refReviewStart"
                :close-on-content-click="false"
                v-model="menuReviewStart"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px">
              <v-text-field
                  slot="activator"
                  v-model="form.reviewStart"
                  label="申报日期(起始)"
                  :rules="rules.endDate"
                  hint="格式YYYY-MM-DD"
                  persistent-hint
              />
              <v-date-picker
                  v-model="reviewStart"
                  locale="zh-cn"
                  @change="nv => form.reviewStart= nv"
              />
            </v-menu>
          </v-flex>

          <v-flex sm3>
            <v-menu
                ref="refReviewEnd"
                :close-on-content-click="false"
                v-model="menuReviewEnd"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px">
              <v-text-field
                  slot="activator"
                  v-model="form.reviewEnd"
                  label="申报日期(截止)"
                  :rules="rules.endDate"
                  hint="格式YYYY-MM-DD"
                  persistent-hint
              />
              <v-date-picker
                  v-model="reviewEnd"
                  locale="zh-cn"
                  @change="nv => form.reviewEnd= nv"
              />
            </v-menu>
          </v-flex>

          <v-flex sm2>
            <v-autocomplete
                clearable
                v-model="form.code"
                :items="statusItems"
                label="状态"
                :return-object="false"
            />
          </v-flex>

          <v-flex sm1 class="text-xs-right">
            <v-btn color="primary" @click.native="onSearch">
              <v-icon>search</v-icon>检索
            </v-btn>
          </v-flex>

        </v-layout>
      </v-container>
    </v-form>
    <v-divider/>

    <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-0"
        :loading="isLoading"
        :pagination.sync="query"
        :rows-per-page-items="[25, 50, 100]"
        no-data-text="没有数据。">
      <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td>{{ props.index + 1 }}</td>
        <td>{{ props.item.name }}</td>

        <td>
          {{ props.item.ifPreReview }}
          <br/>
          {{ props.item.ifAnonymousLooseLeaf }}
        </td>

        <td>
          {{ props.item.startDate }}
          <br/>
          {{ props.item.finishDate }}
        </td>

        <td>{{ props.item.pubDate }}</td>
        <td>{{ props.item.operator }}</td>

        <td class="justify-center">
          <v-tooltip top>
            <v-chip small label class="mx-0" slot="activator"
                    :color="props.item.status.color"
                    @click="() => { history=props.item.history; hist = true; }">
              {{ props.item.status.name }}
            </v-chip>
            <span>点击查看审核历史</span>
          </v-tooltip>
        </td>

        <td>
        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { viewDbid = props.item.dbid; view = true; }">
            <v-icon color="teal">more_horiz</v-icon>
          </v-btn>
          <span>查看</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { $router.push(`/proj/review/manage/${props.item.dbid}`) }">
            <v-icon color="teal">toc</v-icon>
          </v-btn>
          <span>管理/查看</span>
        </v-tooltip>

        <v-tooltip top>
          <v-btn icon class="mx-0" slot="activator"
                 @click="() => { deleDbid = props.item.dbid; deleMsg = props.item.name; dele = true; }"
                 :disabled="submitDisabled(props.item)">
            <v-icon color="pink">delete_forever</v-icon>
          </v-btn>
          <span>删除</span>
        </v-tooltip>
        </td>

      </template>
    </v-data-table>

    <x-view
        v-model="view"
        :dbid="viewDbid"
    />

    <x-edit
        v-model="edit"
        :dbid="editDbid"
        v-on:ok="onEditOk"
    />

    <x-history
        v-model="hist"
        :history="history"
        :status="statusItems"
    />

    <x-delete
        v-model="dele"
        :message="deleMsg"
        :uri="uri"
        :dbid="deleDbid"
        v-on:ok="onEditOk"
    />

  </v-card>
</template>

<script>
import XEdit from './Edit'
import XHistory from '@/components/global/History'
import XView from './ViewReview'
import XDelete from '@/components/global/Delete'
const baseUri = '/api/proj/review';
const baseURI = '/api/proj/review/by/request/user';
const reviewStatusUri = '/api/proj/review-status';
const statusUri = '/api/proj/status';
export default {
  name: "Index",
  components: {XEdit, XHistory, XView, XDelete},
  data: () => ({
    uri: baseUri,
    form: {
      name: "",
      reviewStart: "",
      reviewEnd: "",
    },

    query: {
      page: 1,
      rowsPerPage: 25,
      sortBy: 'rkrq',
      descending: true,
      totalItems: null
    },

    items: [],
    isLoading: false,

    headers: [
      {
        text: '#',
        sortable: false,
        value: 'dbid',
        width: "5%"
      },
      {text: '申报名称', sortable: false, value: 'name', align: 'left', width: "26%"},
      {text: '初审 / 匿名活页', sortable: false, value: 'ifPreReview', width: "10%", align: 'center'},
      {text: '开始日期 / 截止日期', align: 'center', sortable: false, value: 'startDate', width: "15%" },
      {text: '发布日期', value: 'pubDate', sortable: false, align: 'center', width: "10%"},
      {text: '发布人', value: 'operator', sortable: false, align: 'center', width: "9%"},
      {text: '状态',  sortable: false, align: 'center', width: "10%"},
      {text: '操作',  sortable: false, align: 'center', width: "15%"}
    ],

    reviewStart: '',
    menuReviewStart: false,

    reviewEnd: '',
    menuReviewEnd: false,

    newReview: false,

    view: false,
    viewDbid: null,

    edit: false,
    editDbid: null,

    hist: false,
    history: [],

    dele: false,
    deleDbid: null,
    deleMsg: null,

    statusItems: [],
    /**
     * 验证规则
     */
    rules: {}
  }),
  methods: {
    onSearch() {
      Object.assign(this.query, this.form);
      this.query.page = 1;
      this.isLoading = true;
      this.axios.get(baseURI, {params: window.xutil.toApiQuery(this.query)})
          .then(
              rsp => {
                this.isLoading = false;
                this.items = rsp.data.items;
              })
          .finally(() => this.isLoading = false);
    },
    onEditOk() {
      window.console.log("mmmmm")
      Object.assign(this.query, this.form);
      this.query.page = 1;
      this.isLoading = true;
      this.axios.get(baseURI, {params: window.xutil.toApiQuery(this.query)})
          .then(
              rsp => {
                this.isLoading = false;
                this.items = rsp.data.items;
              })
          .finally(() => this.isLoading = false);
    },
    submitDisabled(item) {
      return !(
          // 当前用户拥有提交功能
          item.actions.find(a => a.action === 'pub'))
    },
  },
  mounted() {
    Object.assign(this.query, this.form);
    this.query.page = 1;
    this.isLoading = true;
    this.axios.get(baseUri, {params: window.xutil.toApiQuery(this.query)})
        .then(
            rsp => {
              this.isLoading = false;
              this.items = rsp.data.items;
              window.console.log(this.items)
            })
        .finally(() => this.isLoading = false);
  },
  created() {
    let t = 'review'
    this.axios.all([
      this.axios.get(reviewStatusUri, {params: {sort: 'rank.asc'}}),
      this.axios.get(`${statusUri}/${t}`, {params: {sort: 'rank.asc'}}),])
        .then(
            this.axios.spread(
                (rspReviewStatus,rspStatus) => {
                  this.isLoading = false;
                  this.statusItems = rspStatus.data;
                  window.console.log("this.statusItems")
                  window.console.log(this.statusItems)
                  this.reviewStatusItems = rspReviewStatus.data.items;
                })
        )
  }
}
</script>

<style scoped>

</style>